import axios from 'axios';

export const API_URL = process.env.REACT_APP_API_URL;


// Base URL for the API
const API = axios.create({
  baseURL: `${API_URL}api/`,
});

// Without Variants
// export const addToCart = async (productId, token) => {
//   try {
//     const response = await API.post(`add-to-cart/${productId}/`, null, {
//       headers: {
//         Authorization: `Bearer ${token}`,  // Ensure Bearer prefix is included
//       },
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error adding to cart:", error.response);
//     throw error;
//   }
// };

// With Variants testing 
export const addToCart = async (productId, token, variantId = null) => {
  try {
    const response = await API.post(
      `add-to-cart/${productId}/`,
      { variant_id: variantId },  // Send variant ID in the request body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error adding to cart:", error.response);
    throw error;
  }
};



// Fetch all products
export const fetchProducts = async () => {
  const response = await API.get('products/');
  // console.log(API);
  // console.log(response);
  return response.data;
};

// Original Product by id function

// export const fetchProductById = async (id) => {
//   const response = await API.get(`products/${id}/`);
//   const product = response.data;

//   // Helper function to clean URLs
//   const cleanImageUrl = (imageUrl) => {
//     if (!imageUrl) return '';

//     // If the URL contains Shopify and is prefixed with localhost media, strip the local part
//     if (imageUrl.includes("shopify.com") && imageUrl.includes("127.0.0.1:8000/media/")) {
//       return decodeURIComponent(imageUrl.replace("http://127.0.0.1:8000/media/", ""));
//     }
//     if (imageUrl.includes("shopify.com") && imageUrl.includes(`localhost:8000/media/`)) {
//       return decodeURIComponent(imageUrl.replace("http://localhost:8000/media/", ""));
//     }

//     // Handle API_URL case - this check should be against imageUrl, not product.image
//     if (imageUrl.includes("shopify.com") && imageUrl.includes(`${API_URL}media/`)) {
//       let fixedImage = decodeURIComponent(imageUrl.replace(`${API_URL}media/`, ""));

//       // Fix the missing slash in the protocol
//       if (fixedImage.startsWith("https:/") && !fixedImage.startsWith("https://")) {
//         fixedImage = fixedImage.replace("https:/", "https://");
//       } else if (fixedImage.startsWith("http:/") && !fixedImage.startsWith("http://")) {
//         fixedImage = fixedImage.replace("http:/", "http://");
//       }

//       return fixedImage; // Return the fixed image URL
//     }

//     return imageUrl; // Return the original URL if no changes were made
//   };

//   // Clean product image
//   product.image = cleanImageUrl(product.image);

//   // Clean variant images
//   if (product.variants && Array.isArray(product.variants)) {
//     product.variants = product.variants.map(variant => {
//       console.log("Before cleaning:", variant.image);
//       const cleanedImage = cleanImageUrl(variant.image);
//       console.log("After cleaning:", cleanedImage);
//       return {
//         ...variant,
//         image: cleanedImage
//       };
//     });
//   }

//   return product;
// };

export const fetchProductById = async (id) => {
  const response = await API.get(`products/${id}/`);
  const product = response.data;

  // Helper function to clean URLs
  const cleanImageUrl = (imageUrl) => {
    if (!imageUrl) return '';

    // If the URL contains Shopify and is prefixed with localhost media, strip the local part
    if (imageUrl.includes("shopify.com") && imageUrl.includes("127.0.0.1:8000/media/")) {
      return decodeURIComponent(imageUrl.replace("http://127.0.0.1:8000/media/", ""));
    }
    if (imageUrl.includes("shopify.com") && imageUrl.includes(`localhost:8000/media/`)) {
      return decodeURIComponent(imageUrl.replace("http://localhost:8000/media/", ""));
    }

    // Handle API_URL case - this check should be against imageUrl, not product.image
    if (imageUrl.includes("shopify.com") && imageUrl.includes(`${API_URL}media/`)) {
      let fixedImage = decodeURIComponent(imageUrl.replace(`${API_URL}media/`, ""));

      // Fix the missing slash in the protocol
      if (fixedImage.startsWith("https:/") && !fixedImage.startsWith("https://")) {
        fixedImage = fixedImage.replace("https:/", "https://");
      } else if (fixedImage.startsWith("http:/") && !fixedImage.startsWith("http://")) {
        fixedImage = fixedImage.replace("http:/", "http://");
      }

      return fixedImage; // Return the fixed image URL
    }

    return imageUrl; // Return the original URL if no changes were made
  };

  // Clean product image (legacy support for old products with single image)
  if (product.image) {
    product.image = cleanImageUrl(product.image);
  }

  // Clean product images array
  if (product.images && Array.isArray(product.images)) {
    product.images = product.images.map(img => ({
      ...img,
      image: cleanImageUrl(img.image)
    }));
  }

  // Clean variant images
  if (product.variants && Array.isArray(product.variants)) {
    product.variants = product.variants.map(variant => {
      // Handle single variant image (legacy support)
      if (variant.image) {
        variant.image = cleanImageUrl(variant.image);
      }
      
      // Handle variant images array
      if (variant.images && Array.isArray(variant.images)) {
        variant.images = variant.images.map(img => ({
          ...img,
          image: cleanImageUrl(img.image)
        }));
      } else {
        variant.images = []; // Ensure images array exists
      }
      
      return variant;
    });
  }

  console.log("Processed product data:", product);
  return product;
};

// Fetch all businesses
export const fetchBusinesses = async () => {
  const response = await API.get('businesses/');
  return response.data;
};

export const fetchProductsByBusinessId = async (businessId) => {
  const response = await API.get(`products-by-business/${businessId}/`);
  return response.data;
};

export const fetchBusinessById = async (id) => {
  const response = await API.get(`business/${id}/`);
  return response.data;
};

// Edit a product
export const editProduct = async (productId, updatedProductData, token) => {
  try {
    const response = await API.put(`products/${productId}/`, updatedProductData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error editing product:", error.response);
    throw error;
  }
};

// Delete a product
export const deleteProduct = async (productId, token) => {
  try {
    const response = await API.delete(`products/${productId}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting product:", error.response);
    throw error;
  }
};

// export const checkout = async (token) => {
//   try {
//     const response = await API.post(`checkout/`, null, {
//       headers: {
//         Authorization: `Bearer ${token}`, // Include Bearer prefix for authentication
//       },
//     });
//     return response.data; // Return the response data
//   } catch (error) {
//     console.error("Error during checkout:", error.response);
//     throw error;
//   }
// };

export const checkout = async (token, cart) => {
  try {
    const response = await API.post(`checkout/`, {
      items: cart.items.map(item => ({
        product_id: item.product,
        variant_id: item.variant_id, // Send the variant ID if it exists
        quantity: item.quantity,
      })),
    }, {
      headers: {
        Authorization: `Bearer ${token}`, // Include Bearer prefix for authentication
      },
    });
    return response.data; // Return the response data
  } catch (error) {
    console.error("Error during checkout:", error.response);
    throw error;
  }
};


